import { DefaultEntity, KitAttributes } from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class KitAttributeService extends BaseService<
  'kitAttribute',
  DefaultEntity & KitAttributes,
  KitAttributes
> {
  constructor() {
    super('kits');
  }

  updateAttributes = (payload: {
    kitId: string;
    data: KitAttributes[];
  }): Promise<KitAttributes[]> => {
    const { kitId, data } = payload;

    return APIService.patch(this.path + `/${kitId}/attribute`, data);
  };

  uploadBulkAttributes = (payload: {
    serial: string;
    data: FormData;
  }): Promise<KitAttributes[]> => {
    const { serial, data } = payload;

    return APIService.patch(this.path + `/${serial}/bulk-attributes`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };
}

export const kitAttributeService = new KitAttributeService();
